import { useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoaderCard } from "../../common/Loader";
import { getPercentage, getProportionalSeat, translate, translateNumber, translatePercentage } from "../../../helper";
import { ASSET_HOST_BASE_URL, otherParty, PROPORTIONAL_SEAT } from "../../../config";
import LangContext from "../../../contexts/LangContext";

import "./index.css";
const toBeExcludedParties = ["NGGP", "NNJP", "CNP", "SUP", "CPNS", "SPN"];
const PRSummary = (props) => {
  const { fetched, result } = props;
  const { lang } = useContext(LangContext);
  let [provinceTab, setProvinceTab] = useState(1);

  const drawChart = useCallback(
    (result) => {
      const chartData = JSON.parse(JSON.stringify(result.data.filter((pr) => !toBeExcludedParties.includes(pr.party)).filter((x, i) => i < 10)));
      const totalCount = chartData.reduce((x, y) => x + y.vote, 0);
      let chartHeight = 500;

      // try {
      //   chartHeight = document.querySelector(".sh-pr-card").offsetHeight;
      // } catch (e) {
      //   console.warn(e);
      // }

      new window.Highcharts.Chart({
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
          height: chartHeight,
          renderTo: "global-prop-pie-" + result.province,
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          spacingBottom: 10,
          spacingTop: 10,
          spacingLeft: 10,
          spacingRight: 10,
          reflow: true,
        },
        title: {
          text: "",
          align: "center",
          verticalAlign: "middle",
          y: 10,
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br/>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.x} ({point.z})</b><br/>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: false,
              format: "{point.name}",
            },
            showInLegend: true,
          },
        },
        legend: {
          padding: 10,
          symbolHeight: 18,
          symbolWidth: 18,
          symbolRadius: 9,
          itemMarginTop: 12,
        },
        series: [
          {
            type: "pie",
            name: translate("seat", lang),
            data: chartData.map((d, i) => {
              const partyDetail = props.parties.find((par) => par.code === d.party) || otherParty;
              return {
                name: partyDetail["short_name_" + lang] || partyDetail["name_" + lang],
                x: translateNumber(((d.vote / parseFloat(totalCount)) * 100).toFixed(2), lang).toString() + "%",
                y: d.vote,
                z: translateNumber(d.vote, lang),
                color: partyDetail.color,
                // sliced: i === 0 ? true : false,
                selected: true,
              };
            }),
          },
        ],
        credits: {
          enabled: false,
        },
      });
    },
    [lang, props.parties]
  );

  const rtype = props.tab ? props.tab : "federal";

  if (rtype === "federal") {
    provinceTab = 0;
  }

  let prData = Object.keys(result).length > 0 ? result[rtype] : [];
  useEffect(() => {
    let prData = Object.keys(result).length > 0 ? result[rtype] : [];
    if (fetched) {
      setTimeout(() => {
        drawChart(prData[0]);
      }, 50);
    }
    const elemContainer = document.querySelector(".sh-global-prop-section .container");
    const elemPartyAll = document.querySelector(".sh-global-prop-section .sh-pr-all-party");
    const rightM = parseFloat(window.getComputedStyle(elemContainer).marginRight.replace("px", ""));
    const rightP = parseFloat(window.getComputedStyle(elemContainer).paddingRight.replace("px", ""));
    elemPartyAll.style.right = rightM + rightP + "px";
  }, [drawChart, fetched, result, rtype]);

  const handleProvinceTabClick = (el) => {
    let province = "1";
    if (el.target.tagName === "LI") {
      province = el.target.parentElement.getAttribute("datavalue");
    } else {
      province = el.target.getAttribute("datavalue");
    }
    setProvinceTab(parseInt(province));

    setTimeout(() => {
      drawChart(prData.find((pd) => pd.province === parseInt(province)));
    }, 50);
  };

  return (
    <section className="sh-global-prop-section">
      <div className="container">
        <div className="sh-pr-all-party">
          <div className="row mt-3">
            <div className="col-md-12">
              <Link to={"/proportional/allparties"}>{translate("all_parties", lang)}</Link>
            </div>
          </div>
        </div>
        <div className="container-fluid card sh-card-summary">
          <div className="row mb-3">
            <div className="col-md-12">
              <h1 className="text-center">{translate("proportional", lang) + " " + translate("vote", lang) + " " + translate("result", lang)}</h1>
            </div>
          </div>
          {rtype === "provincial" && (
            <nav className="sh-prov-nav-tab-section">
              <div className="nav nav-tabs d-flex justify-content-center" id="nav-tab" role="tablist">
                {props.provinces.map((prov, i) => {
                  return (
                    <button key={i} onClick={handleProvinceTabClick} datavalue={prov.id} className={prov.id === provinceTab ? "nav-link active" : "nav-link"} data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                      <li>{prov["name_" + lang]}</li>
                    </button>
                  );
                })}
              </div>
              <br />
            </nav>
          )}
          {!fetched ? (
            <>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <div className="mt-5"></div>
              <LoaderCard />
            </>
          ) : (
            prData
              .filter((p) => p.province === provinceTab)
              .map((result, i) => {
                const maxVote = result.data[0].vote;

                const { nationalParties, grandTotal, pr_results, totalVote } = getProportionalSeat(result.data, provinceTab);

                // const others = result.data.filter((x, i) => i > 9);
                // const otherVote = others.reduce((a, b) => a + b.vote, 0);

                // if (others) {
                //   result.data.push({ party: "O", vote: otherVote });
                // }

                return (
                  <div className="row" key={i} style={{ opacity: fetched ? "1" : 0.5 }}>
                    <div className="col-md-7 col-sm-12 col-xs-12 sh-pl-20">
                      <div className="container-fluid card sh-pr-card">
                        <br />
                        <table className="table-striped mb-3" width="100%">
                          <thead>
                            <tr>
                              <th className="pd-10">{translate("party", lang)}</th>
                              <th></th>
                              <th className="sh-right">{translate("seat", lang)}</th>
                              <th className="sh-right pd-10">{translate("vote", lang)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pr_results.map((d, j) => {
                              const party = props.parties.find((par) => par.code === d.party) || otherParty;
                              const nationalParty = nationalParties.find((np) => np.party === d.party);

                              return (
                                <tr key={j}>
                                  <td>
                                    <div className="pd-10">
                                      <label>
                                        <img
                                          src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                                          alt={party.code.toUpperCase()}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                          }}
                                          className="pull-left sh-party-symbol"
                                          width="20px"
                                          height="20px"
                                        />
                                        {party["short_name_" + lang] || party["name_" + lang]}
                                      </label>
                                    </div>
                                  </td>
                                  <td width={"40%"}>
                                    <div className="progress mb-0">
                                      <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(d.vote, maxVote), backgroundColor: party.color, opacity: 1 }}>
                                        {translatePercentage(d.vote, totalVote, lang)}
                                      </div>
                                    </div>
                                  </td>
                                  <td width={"10%"}>
                                    <div className="sh-right">{nationalParty ? translateNumber(nationalParty.seat, lang) : "-"}</div>
                                  </td>
                                  <td>
                                    <div className="sh-right pd-10">
                                      <span>{translateNumber(d.vote, lang)}</span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                            <tr>
                              <td>
                                <div className="pd-10">
                                  <label>
                                    <b>{translate("total", lang)}</b>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <label className="sh-progress-bar-label" htmlFor=""></label>
                                  {/* <div className="progress">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(0, 1), backgroundColor: "#00ff00", opacity: 1 }}></div>
                                  </div> */}
                                </div>
                              </td>
                              <td>
                                <b>
                                  <span className="pull-right data">{translateNumber(PROPORTIONAL_SEAT[provinceTab], lang)}</span>
                                </b>
                              </td>
                              <td>
                                <b>
                                  <span className="pull-right pd-10 data">{translateNumber(grandTotal, lang)}</span>
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="col-md-5 col-sm-12 col-xm-12 sh-pr-20">
                      <div className="container-fluid card">
                        <div className="row">
                          <div className="col-md-12 col-sm-12">
                            <div id={"global-prop-pie-" + result.province} style={{ width: "100%" }} className="hidden-xs"></div>
                          </div>
                          <div className="col-md-1 col-sm-1" style={{ display: "none" }}>
                            <ul className="legend-party">
                              {result.data.map((d, i) => {
                                const party = props.parties.find((par) => par.code === d.party) || otherParty;
                                return (
                                  <li className="box" key={i}>
                                    <span className="sh-party-color" style={{ backgroundColor: party.color }}></span> <label>{party["short_name_" + lang] || party["name_" + lang]}</label>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
          )}
        </div>
        {props.tab === "federal" && (
          <div className="row mt-3">
            <div className="col-md-12">
              <Link to={"/proportional/fcandidates"}>{translate("federal", lang) + " " + translate("proportional", lang) + " " + translate("candidates", lang)}</Link>
            </div>
          </div>
        )}
        {props.tab === "provincial" && (
          <div className="row">
            <div className="col-md-12">
              <Link to={"/proportional/pcandidates"}>{translate("provincial", lang) + " " + translate("proportional", lang) + " " + translate("candidates", lang)}</Link>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PRSummary;
